import PropTypes from 'prop-types';

/**
 * The BatchGenius product mark: an open loop with a start arrowhead and a solid core —
 * a batch runs a defined cycle and closes. Kept as inline SVG so it stays crisp at any size
 * and inherits no external asset. The raster variants for the tab, home screen and PWA live
 * in public/ (favicon.svg, icon-32/192/512, apple-touch-icon, icon-maskable-512).
 *
 * This is the *product* mark. The Nexgensis corporate logo stays on the login screen and the
 * printed records — the two are meant to sit side by side, not replace each other.
 */
const BatchGeniusMark = ({ size = 32, ground = '#0E6C7A', stroke = '#FFFFFF', core = '#7FD6E2', rounded = true, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="BatchGenius" {...rest}>
    {ground && <rect width="64" height="64" rx={rounded ? 15 : 0} fill={ground} />}
    <path d="M32 15.5 A16.5 16.5 0 1 1 15.51 32.58" stroke={stroke} strokeWidth="5" strokeLinecap="round" fill="none" />
    <path d="M32 10.9 L22.5 15.5 L32 20.1 Z" fill={stroke} />
    <circle cx="32" cy="32" r="6.5" fill={core} />
  </svg>
);

BatchGeniusMark.propTypes = {
  size: PropTypes.number,
  ground: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]),
  stroke: PropTypes.string,
  core: PropTypes.string,
  rounded: PropTypes.bool,
};

export default BatchGeniusMark;
